import React from 'react';
import QueuePositionMessage from './QueuePositionMessage';

export default class QueuePosition extends React.Component {
    constructor(props) {
        super(props);
    }


    render() {
        return(
            <div className='queue-position' aria-live='polite'>
                <QueuePositionMessage payload = {this.props.payload}></QueuePositionMessage>
            </div>
        );
    }
}